window.initRecentlyViewed = function () {
  const containers = document.querySelectorAll('.recently-viewed-container');
  if (!containers.length) return;
  // Retrieve valid product IDs
  const ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
  const currentId = (document.querySelector('[data-product-id]') || {}).dataset?.productId;
  const filteredIds = currentId ? ids.filter(id => String(id) !== String(currentId)) : ids;
  const maxItems = 10;
  const limitedIds = filteredIds.slice(0, maxItems);
  // If no recently viewed products found, section remains hidden
  if (!limitedIds.length) {
    containers.forEach(container => {
      const groupBlock = container.closest('.group-block') || container.closest('.recently-viewed') || container.closest('.block-recently-viewed');
      if (groupBlock) {
        groupBlock.style.display = 'none';
      }
    });
    return;
  }
  const query = limitedIds.map(id => `id:${id}`).join(' OR ');
  containers.forEach(container => {
    if (container.dataset.isFetching === 'false' && container.style.display === 'none') {
      const sectionId = container.dataset.sectionId;
      if (!sectionId) return;
      const searchUrl = `${window.Shopify.routes.root}search?type=product&q=${encodeURIComponent(query)}&section_id=${sectionId}`;
      fetch(searchUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.getElementById(`recently-viewed-${sectionId}`);
          if (newSection && newSection.innerHTML.trim() !== '') {
            container.innerHTML = newSection.innerHTML;
            container.style.display = '';
            // Initialization queue
            setTimeout(() => {
              if (typeof initRVSwiperForContainer === 'function') {
                initRVSwiperForContainer(container);
              }
            }, 50);
            setTimeout(() => {
              container.querySelectorAll('slideshow-component').forEach(slideshowEl => {
                const scroller = slideshowEl.querySelector('slideshow-slides');
                const thumb = slideshowEl.querySelector('.slideshow-scrollbar__thumb');
                if (!scroller || !thumb) return;
                function updateProgress() {
                  const slides = scroller.children.length;
                  if (slides <= 0) {
                    thumb.style.setProperty('--scroll-progress', 0);
                    return;
                  }
                  const { scrollLeft, scrollWidth, clientWidth } = scroller;
                  const maxScroll = scrollWidth - clientWidth;
                  let scrollProgress = maxScroll > 0 ? scrollLeft / maxScroll : 0;
                  const base = 1 / slides;
                  const progress = base + scrollProgress * (1 - base);
                  thumb.style.setProperty('--scroll-progress', progress.toFixed(4));
                }
                scroller.addEventListener('scroll', updateProgress, { passive: true });
                requestAnimationFrame(updateProgress);
              });
            }, 60);
          } else {
            const groupBlock = container.closest('.group-block') || container.closest('.recently-viewed') || container.closest('.block-recently-viewed');
            if (groupBlock) {
              groupBlock.style.display = 'none';
            }
          }
        })
        .catch(e => {
          if (e && (e.name === 'AbortError' || e === 'canceled' || e.message === 'canceled')) return;
          console.warn('Recently Viewed Error:', e);
        });
    } else {
      // If loaded directly in theme editor, init immediately
      initRVSwiperForContainer(container);
    }
  });
};

document.addEventListener('DOMContentLoaded', function () {
  window.initRecentlyViewed();
});
window.addEventListener('load', function () {
  window.initRecentlyViewed();
});
document.addEventListener('account-drawer:hydrated', function () {
  window.initRecentlyViewed();
});
function initRVSwiperForContainer(rootContainer) {
  const container = rootContainer.querySelector('.rv-swiper');
  if (!container || typeof Swiper === 'undefined') return;
  const slides = container.querySelectorAll('.swiper-slide');
  if (slides.length === 0) return;
  const gap = parseFloat(getComputedStyle(container).getPropertyValue('--rv-gap')) || 8;
  const hasEnoughForLoop = slides.length >= 6;
  const sliderMode = container.getAttribute('data-slider-mode') || 'option2';
  const isOption1 = sliderMode === 'option1';
  let offsetPadding = 0;
  function updateOption1Layout() {
    if (isOption1 && window.innerWidth >= 750) {
      const headerTitle = rootContainer.querySelector('.section-resource-list__header');
      if (headerTitle) {
        const computed = window.getComputedStyle(headerTitle);
        const paddingLeft = parseFloat(computed.paddingLeft) || 0;
        offsetPadding = headerTitle.getBoundingClientRect().left + paddingLeft;
        container.style.setProperty('--option1-offset', offsetPadding + 'px');
      }
    }
  }
  updateOption1Layout();
  // Handle window resize offsets for Option 1
  let swiperInstance = null;
  window.addEventListener('resize', () => {
    if (isOption1 && window.innerWidth >= 750 && swiperInstance) {
      updateOption1Layout();
      swiperInstance.params.slidesOffsetBefore = offsetPadding;
      swiperInstance.params.slidesOffsetAfter = offsetPadding;
      swiperInstance.update();
    }
  });
  swiperInstance = new Swiper(container, {
    spaceBetween: gap,
    allowTouchMove: false,
    navigation: {
      nextEl: rootContainer.querySelector('.rv-slider-next'),
      prevEl: rootContainer.querySelector('.rv-slider-prev'),
    },
    pagination: {
      el: rootContainer.querySelector('.swiper-pagination'),
      type: 'progressbar',
    },
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      },
      750: {
        slidesPerView: 'auto',
        // centeredSlides: isOption1 ? false : true,
        loop: isOption1 ? false : hasEnoughForLoop,
        // slidesOffsetBefore: isOption1 ? offsetPadding : 0,
        // slidesOffsetAfter: isOption1 ? offsetPadding : 0
        slidesOffsetAfter: 16,
        slidesOffsetBefore: 16
      }
    },
    on: {
      init: function () {
        const isMobile = window.innerWidth <= 749;
        const arrows = rootContainer.querySelector('slideshow-arrows');
        const progressbar = rootContainer.querySelector('.swiper-pagination');
        if (isMobile) {
          if (arrows) arrows.style.display = 'none';
          if (progressbar) progressbar.style.display = 'block';
        } else {
          if (arrows) arrows.style.display = 'block';
          if (progressbar) progressbar.style.display = 'none';
        }
        setArrowPosition();
      },
      resize: function () {
        const isMobile = window.innerWidth <= 749;
        const arrows = rootContainer.querySelector('slideshow-arrows');
        const progressbar = rootContainer.querySelector('.swiper-pagination');
        if (isMobile) {
          if (arrows) arrows.style.display = 'none';
          if (progressbar) progressbar.style.display = 'block';
        } else {
          if (arrows) arrows.style.display = 'block';
          if (progressbar) progressbar.style.display = 'none';
        }
        setArrowPosition();
      }
    }
  });
  function setArrowPosition() {
    const firstImg = container.querySelector('.image-block__image, .product-media__image');
    if (firstImg) {
      const imgH = firstImg.offsetHeight;
      container.style.setProperty('--arrow-top', (imgH / 2) + 'px');
    }
  }
}
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.recently-viewed-container')) {
      initRVSwiperForContainer(event.target.querySelector('.recently-viewed-container'));
    }
  });
}